/**
 * Rimuove il codice numerico iniziale usato nei cataloghi ECM (es. "5 Psicologo" → "Psicologo").
 */
export function stripEcmCatalogPrefix(line: string): string {
  return line.replace(/^\d+\s+/, '').trim();
}
